/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CaiDanChuangJianDTO,
  CaiDanGengXinDTO,
  CaiDanShanChuDTO,
  QuanXianBianJiDTO,
  QuanXianChaXunDTO,
  QuanXianChuangJianDTO,
  QuanXianShanChuDTO,
  ResponseApiBoolean,
  ResponseApiListApiPermissionDTO,
  ResponseApiListPermissionTreeDTO,
  ResponseApiListQuanXianXiangQingDTO,
  ResponseApiLong,
  ResponseApiUserMenuPermissionDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class QuanXianGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name GetApiPermissionListUsingPost
   * @summary 查询所有接口权限列表
   * @request POST:/dsp-admin/api/permission/apiList
   * @secure
   */
  getApiPermissionListUsingPost = (
    queryDTO: QuanXianChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListApiPermissionDTO, void>({
      path: `/dsp-admin/api/permission/apiList`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name CreatePermissionUsingPost
   * @summary 创建权限
   * @request POST:/dsp-admin/api/permission/create
   * @secure
   */
  createPermissionUsingPost = (
    dto: QuanXianChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/permission/create`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name DeletePermissionUsingPost
   * @summary 删除权限（软删除）
   * @request POST:/dsp-admin/api/permission/delete
   * @secure
   */
  deletePermissionUsingPost = (
    dto: QuanXianShanChuDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/permission/delete`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name GetFullPermissionTreeUsingPost
   * @summary 获取完整权限树（包含接口权限，用于授权展示）
   * @request POST:/dsp-admin/api/permission/fullTree
   * @secure
   */
  getFullPermissionTreeUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiListPermissionTreeDTO, void>({
      path: `/dsp-admin/api/permission/fullTree`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name CreateMenuUsingPost
   * @summary 创建菜单
   * @request POST:/dsp-admin/api/permission/menu/create
   * @secure
   */
  createMenuUsingPost = (
    dto: CaiDanChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/permission/menu/create`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name DeleteMenuUsingPost
   * @summary 删除菜单（软删除）
   * @request POST:/dsp-admin/api/permission/menu/delete
   * @secure
   */
  deleteMenuUsingPost = (dto: CaiDanShanChuDTO, params: RequestParams = {}) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/permission/menu/delete`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name UpdateMenuUsingPut
   * @summary 更新菜单
   * @request PUT:/dsp-admin/api/permission/menu/{menuId}
   * @secure
   */
  updateMenuUsingPut = (
    menuId: number,
    dto: CaiDanGengXinDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/permission/menu/${menuId}`,
      method: "PUT",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name GetMenuListUsingPost
   * @summary 获取菜单列表（用于权限管理，返回平铺菜单列表）
   * @request POST:/dsp-admin/api/permission/menuList
   * @secure
   */
  getMenuListUsingPost = (
    queryDTO: QuanXianChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListQuanXianXiangQingDTO, void>({
      path: `/dsp-admin/api/permission/menuList`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name GetMenuTreeUsingPost
   * @summary 获取所有菜单树
   * @request POST:/dsp-admin/api/permission/tree
   * @secure
   */
  getMenuTreeUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiUserMenuPermissionDTO, void>({
      path: `/dsp-admin/api/permission/tree`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name GetUserMenusUsingPost
   * @summary 获取当前用户的菜单权限
   * @request POST:/dsp-admin/api/permission/userMenus
   * @secure
   */
  getUserMenusUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiUserMenuPermissionDTO, void>({
      path: `/dsp-admin/api/permission/userMenus`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags QuanXianGuanLi
   * @name UpdatePermissionUsingPut
   * @summary 更新权限
   * @request PUT:/dsp-admin/api/permission/{permissionId}
   * @secure
   */
  updatePermissionUsingPut = (
    permissionId: number,
    dto: QuanXianBianJiDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/permission/${permissionId}`,
      method: "PUT",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new QuanXianGuanLi();
